<template >
<div class="container-fluid">


 <div class="modal" id="CouponIdentification" role="dialog" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered  " >
    
    <div class="modal-content border border-info">
      <div class="modal-header ">
        <h4 class="modal-title" id="staticBackdropLabel">
          <i class="fas fa-search-location mr-3" aria-hidden="true"></i>
          IDENTIFICAZIONE COUPON </h4>
       <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>-->
      </div>
      <form v-on:submit.prevent="submit()">
     
       
      <div class="modal-body mt-1">   
        
        <div class="">
           
            <label for="inputEan" class="form-label">Inserire il codice a barre del Coupon</label>            
            <input  required type="number" id="couponBarcode" class="form-control" v-model="coupon.barcode" >            
            <alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
        </div>
        
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-dismiss="modal">
            <!--<i style ="color:yellow" class="fas fa-reply mr-3" aria-hidden="true"></i>-->
            CHIUDI</button>

        <!--<button type="submit" class="btn btn-primary">
            <i style ="color:burlywood" class="fas fa-binocular mr-3" aria-hidden="true"></i>
            CERCA</button>-->
      </div>
    </form>
    </div>
    
  </div>
</div>

</div>
</template>
<script>


import api                        from '@/api'
import alertBox                   from '@/components/common/AlertBox.vue';
import { mapGetters }             from 'vuex';


export default {

  components: {alertBox},
  
 data () {
    return {
    
    coupon    : {},
    
    //option    : 0,
    msg : {
        title : '',
        body  : '',
        type  : 0
      },
      

    }
  },
  directives: 
    {
      focus: {
      
        inserted: function (el) {
          
          el.focus()
          }
           
       
      }
    },
  computed: {
    ...mapGetters(['company','storeId']) 
  },
mounted()
{

 //this.getData()

  
},  
created()
{
  
 // this.initCoupon()
  
},
methods :{

 

async submit()
{
  
  this.msg.title = ''
  const sp    = { 'sp'          : 'spCouponIdentification'}
  const data  = { 'barcode'     : this.coupon.barcode,
                  'companyId'   : this.company.Id,
               
    }  
  let json  = Object.assign(data, sp)

  this.spinner = true
  await api.post(json).then(res => {
          
       
          if(res.status==200)
            {
              
              let coupon = res.data.recordsets[0][0]
              if(coupon)
              {  
                if(coupon.active == 0)
                {
                    this.msg.title = 'ATTENZIONE '
                    this.msg.body  = 'COUPON NON ATTIVO.'
                    this.msg.type  = 1    
                }
                else
                {
                    this.$emit('update',coupon)
                    this.coupon.barcode = ''
                }
              }
              else
              {
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = 'COUPON NON TROVATO'
                this.msg.type  = 1
              }


            }
           else if(res.status==500)
           {
               
       
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res.data
                this.msg.type  = 1
                
                    
           } 
           else
            {
                                 
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res
                this.msg.type  = 1
                
                 
            } 
          

          }).catch(err => {
              

              this.msg.title = 'ATTENZIONE '
              this.msg.body  = err.message
              this.msg.type  = 1
          }).finally(() => {
          this.spinner = false
        });


},



}

}

</script>
<style scoped>


h4 {
  font-family: "Roboto Condensed";
  font-size: 20px;
}
label,legend{
  font-weight: bold;
}
.form-check-label
{
  cursor: pointer;
}
.bigmodal{
  max-width: 35% !important;
  
}
.modal-header
{
    background-color: darkblue; 
    color:aliceblue;
}
</style>
